import { defineMessages } from 'react-intl';

export const newInThisReleaseCardMessages = defineMessages({
  ariaLabel: {
    defaultMessage: 'New in this release',
    id: '/R8poXFEH3',
    description: 'Accessible label for the dictation release awareness card',
  },
  title: {
    defaultMessage: 'New in this release',
    id: 'uiwvxzeZdQ',
    description: 'Heading on the dictation "new in this release" awareness card',
  },
  subtitle: {
    defaultMessage: 'When Dictating you can now...',
    id: 'G3vrucNu4T',
    description: 'Supporting copy under the heading on the dictation release card',
  },
  bulletTone: {
    defaultMessage: 'Customise the tone used across different apps',
    id: 't5ELpWTcSI',
    description: 'First feature bullet on the dictation release card',
  },
  bulletVerbalCommands: {
    defaultMessage: 'Use verbal commands like “period” and “new line”',
    id: 'uTE6275GTb',
    description: 'Second feature bullet on the dictation release card',
  },
  bulletSnippets: {
    defaultMessage: 'Add text snippets with a verbal cue',
    id: 'EkVnJD65FG',
    description: 'Third feature bullet on the dictation release card',
  },
  learnMore: {
    defaultMessage: 'Learn more',
    id: 'wsuHrdk9DG',
    description: 'Secondary CTA opening the dictation help page',
  },
  dismiss: {
    defaultMessage: 'Ok got it',
    id: 'hB92TjMy3N',
    description: 'Primary CTA dismissing the dictation release card',
  },
});
